const throttle = (fn, wait = 300) => {
  let inThrottle;
  let lastFnId;
  let lastTime;
  return function () {
    const context = this;
    const args = arguments;
    if (!inThrottle) {
      fn.apply(context, args);
      lastTime = Date.now();
      inThrottle = true;
    }
    else {
      clearTimeout(lastFnId);
      lastFnId = setTimeout(() => {
        if (Date.now() - lastTime >= wait) {
          fn.apply(context, args);
          lastTime = Date.now();
        }
      }, Math.max(wait - (Date.now() - lastTime), 0));
    }
  };
};

export { throttle as t };
